<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 14:17:13
 * @LastEditTime: 2020-09-22 14:01:06
 * @Description: 添加非第三方员工
-->
<template>
  <div class="add-no-third-party-user">
    <p>
      <span>分公司：</span>
      <i-select v-model="examObject.branchCode" size="small">
        <i-option
          v-for="branch in branchs"
          :key="branch.code"
          :value="branch.code">{{ branch.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>办事处：</span>
      <i-select v-model="examObject.subBranchCode" size="small">
        <i-option
          v-for="subBranch in subBranchs"
          :key="subBranch.code"
          :value="subBranch.code">{{ subBranch.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>渠道：</span>
      <i-select v-model="examObject.channelCode" size="small">
         <i-option
          v-for="channel in channels"
          :key="channel.code"
          :value="channel.code">{{ channel.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>小渠道：</span>
      <i-select v-model="examObject.comChannelCode" size="small">
        <i-option
          v-for="subChannel in subChannels"
          :key="subChannel.code"
          :value="subChannel.code">{{ subChannel.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>用户组：</span>
      <i-select v-model="examObject.groupId" size="small">
        <i-option
          v-for="userGroup in userGroups"
          :key="userGroup.code"
          :value="userGroup.code">{{ userGroup.name }}</i-option>
      </i-select>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

const branchs = [
  { name: '所有分公司', code: 'all' },
  { name: '北京', code: 'N' },
  { name: '成都', code: 'W' },
  { name: '福州', code: 'J' },
  { name: '广州', code: 'S' },
  { name: '杭州', code: 'D' },
  { name: '济南', code: 'I' },
  { name: '南京', code: 'B' },
  { name: '上海', code: 'E' },
  { name: '深圳', code: 'C' },
  { name: '沈阳', code: 'A' },
  { name: '天津', code: 'K' },
  { name: '武汉', code: 'F' },
  { name: '西安', code: 'G' },
];

const subBranchs = [
  { name: '所有办事处', code: 'all' },
];

const channels = [
  { name: '所有渠道', code: 'all' },
  { name: 'Designated', code: 'ZA50' },
  { name: 'NAS', code: 'ZA10' },
  { name: 'RA', code: 'ZA20' },
  { name: 'Web Sales', code: 'ZWEB' },
  { name: 'Direct', code: 'ZA40' },
  { name: 'Fashion Shop Channel', code: 'ZAG0' },
  { name: 'Mobile', code: 'ZAD0' },
  { name: 'Wholesaler', code: 'ZAE0' },
  { name: 'Camera', code: 'ZAF0' },
];

const subChannels = [
  { name: '所有小渠道', code: 'all' },
];

const userGroups = [
  { name: '所有用户组', code: 'all' },
  { name: 'HQ Manager', code: 65 },
  { name: 'Mobile Manager', code: 68 },
  { name: 'SYS ADMIN', code: 79 },
  { name: 'Sales HQ User', code: 84 },
  { name: 'HQ Admin', code: 87 },
  { name: 'test', code: 91 },
  { name: 'HQ HR', code: 503 },
  { name: 'SFMD HQ', code: 600 },
  { name: 'Designated HQ', code: 666 },
  { name: 'CEPS HQ', code: 700 },
  { name: 'VIP', code: 888 },
  { name: 'Vendor Admin', code: 902 },
  { name: 'robot', code: 1001 },
  { name: 'R.C. Leader', code: 500 },
  { name: 'Regional HR', code: 501 },
  { name: 'HR Admin', code: 610 },
  { name: 'P&P PIC', code: 62 },
  { name: 'Designated Sales', code: 64 },
  { name: 'Branch Manager', code: 82 },
  { name: '直营店店长', code: 60 },
  { name: 'City Leader', code: 63 },
  { name: '销售员', code: 66 },
  { name: 'Sub-Branch Manager', code: 80 },
  { name: 'SF PIC', code: 85 },
  { name: 'AR', code: 88 },
  { name: 'OA', code: 89 },
  { name: '物料督导', code: 101 },
  { name: 'Office Admin', code: 502 },
  { name: 'R.C.', code: 504 },
  { name: 'Designated 店员', code: 801 },
  { name: '促销员', code: 81 },
  { name: '批发商', code: 200 },
  { name: '下线管理员', code: 201 },
];

export default {
  name: 'AddNoThirdPartyUser',
  data() {
    return {
      branchs,
      subBranchs,
      channels,
      subChannels,
      userGroups,
      examObject: {
        branchCode: 'all',
        subBranchCode: 'all',
        channelCode: 'all',
        comChannelCode: 'all',
        groupId: 'all',
      },
    };
  },
  computed: {
    ...mapGetters({
      noThirdPartyUserRule: 'createPaperStore/noThirdPartyUserRule',
    }),
    selectBranch() {
      return this.examObject.branchCode;
    },
    selectSubBranch() {
      return this.examObject.subBranchCode;
    },
    selectChannel() {
      return this.examObject.channelCode;
    },
    selectComChannel() {
      return this.examObject.comChannelCode;
    },
    selectUserGroup() {
      return this.examObject.groupId;
    },
  },
  watch: {
    selectBranch(branchCode) {
      this.examObject.subBranchCode = 'all';

      const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
      noThirdPartyUserRule.branchCode = branchCode;
      noThirdPartyUserRule.subBranchCode = 'all';
      this.setNoThirdPartyUserRule({ noThirdPartyUserRule });

      this.requestSubBranchs();
    },
    selectSubBranch(subBranchCode) {
      const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
      noThirdPartyUserRule.subBranchCode = subBranchCode;
      this.setNoThirdPartyUserRule({ noThirdPartyUserRule });
    },
    selectChannel(channelCode) {
      this.examObject.comChannelCode = 'all';

      const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
      noThirdPartyUserRule.channelCode = channelCode;
      noThirdPartyUserRule.comChannelCode = 'all';
      this.setNoThirdPartyUserRule({ noThirdPartyUserRule });

      this.requestSubChanels();
    },
    selectComChannel(comChannelCode) {
      const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
      noThirdPartyUserRule.comChannelCode = comChannelCode;
      this.setNoThirdPartyUserRule({ noThirdPartyUserRule });
    },
    selectUserGroup(groupId) {
      const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
      noThirdPartyUserRule.groupId = groupId;
      this.setNoThirdPartyUserRule({ noThirdPartyUserRule });
    },
  },
  methods: {
    ...mapActions({
      setNoThirdPartyUserRule: 'createPaperStore/invokeSetNoThirdPartyUserRule',
    }),
    /**
     * 请求分公司列表
     */
    async requestSubBranchs() {
      if (this.selectBranch !== 'all') {
        const url = `/sf/queryHeadAction.do?branchCode=${this.selectBranch}&method=fetchSubranches`;
        const result = await axios.get(url);
        this.subBranchs = [{ name: '所有办事处', code: 'all' }, ...result.data];
      } else {
        this.subBranchs = [{ name: '所有办事处', code: 'all' }];
        this.examObject.subBranchCode = 'all';
      }
    },
    /**
     * 请求小渠道列表
     */
    async requestSubChanels() {
      if (this.selectChannel !== 'all') {
        const url = `/sf/queryHeadAction.do?channelCode=${this.selectChannel}&method=fetchCompoChannels`;
        const result = await axios.get(url);
        this.subChannels = [{ name: '所有小渠道', code: 'all' }, ...result.data];
      } else {
        this.subChannels = [{ name: '所有小渠道', code: 'all' }];
        this.examObject.comChannelCode = 'all';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-no-third-party-user {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > p {
    flex: 0 0 calc(100% / 4);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    /deep/ .ivu-select {
      width: 120px;
    }
  }
}
</style>
